
exports.install = function (Vue, options) {
  
    Vue.prototype.reloadPageParam = function (pageParam, listQuery) {
      listQuery.size = pageParam.limit
      listQuery.current = pageParam.page
    }

    Vue.prototype.objToForm = function (params) {
      const formData = new FormData()
      for (const key in params) {
        formData.append(key, params[key] == null ? '' : params[key])
      }
      return formData
    }
  
    Vue.prototype.objToStr = function (params) {
      const newParams = {}
      for (let index in params) {
        newParams[index] = params[index] == null ? '' : params[index].toString();
      }
      return newParams
    }
  
  
  }
  
  


// WEBPACK FOOTER //
// ./src/utils/base.js